import { render, staticRenderFns } from "./rich_text_editor.vue?vue&type=template&id=8c0b429e&scoped=true&"
import script from "./rich_text_editor.vue?vue&type=script&lang=js&"
export * from "./rich_text_editor.vue?vue&type=script&lang=js&"
import style0 from "./rich_text_editor.vue?vue&type=style&index=0&id=8c0b429e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0b429e",
  null
  
)

export default component.exports